// extracted by mini-css-extract-plugin
export default {"socmed":"SocialMedia_socmed__oVn3X"};